import { colors } from "@components/Theme/colors";
import { Box, Container, Stack, Typography } from "@mui/material";
import { APITypes } from "utils/api.types";
import { SPONTANEOUS_APPLICATION } from "../VacatureDetailDescriptionBlock/VacatureDetailDescriptionBlock";
interface VacatureDetailBenefitsBlockProps {
  block: APITypes.Components.ContentBlocks.VacatureDetail;
  position: APITypes.Components.Job;
}
const VacatureDetailBenefitsBlock = ({
  block,
  position
}: VacatureDetailBenefitsBlockProps) => {
  if ([SPONTANEOUS_APPLICATION].includes(position.jobsId)) return null;
  return <Box py={10} sx={{
    backgroundColor: colors.greyColor.light
  }} data-sentry-element="Box" data-sentry-component="VacatureDetailBenefitsBlock" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
        <Stack flexDirection={{
        xs: "column",
        md: "row"
      }} gap={2} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
          <Stack flex={1} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
            <Typography color={colors.secondary.main} sx={{
            fontWeight: 600,
            textAlign: {
              xs: "left",
              md: "right"
            }
          }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
              {block.uspSubTitle}
            </Typography>
            <Typography variant="h2" sx={{
            textAlign: {
              xs: "left",
              md: "right"
            }
          }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
              {block.uspTitle}
            </Typography>
          </Stack>
          <Stack flex={4} sx={{
          mt: {
            xs: 0,
            md: 12
          }
        }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
            <Typography component="div" sx={{
            fontSize: "16px",
            fontWeight: 400,
            "& ul": {
              marginTop: 0
            }
          }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx">
              <Box sx={{
              padding: {
                xs: "0 1rem",
                md: "0"
              },
              ["ul"]: {
                paddingLeft: {
                  xs: "0",
                  md: "40px"
                }
              },
              "& li::marker": {
                content: "'━'",
                color: colors.secondary.main
              },
              "& li": {
                pl: "10px",
                pb: "20px"
              }
            }} dangerouslySetInnerHTML={{
              __html: position.usp
            }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailBenefitsBlock.tsx" />
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>;
};
export default VacatureDetailBenefitsBlock;